//Common Images
import Up from "../assets/booking/up.png";
import userReg from "../assets/Users/userReg.png";
import appStore from "../assets/common/appStore.png";
import playStore from "../assets/common/playStore.png";
import active from "../assets/engegment/activeUsers.png";
import defaultDp from "../assets/common/defaultDp.png";
import CommonDp from "../assets/common/commonDp.png";
import emptyLogo from "../assets/common/emptyLogo.png";
import sender from "../assets/common/sender.png";
import newDp from "../assets/common/sender.png";
import male from "../assets/common/male.png";
import female from "../assets/common/female.png";
import CevIcon from "../assets/sideNav/cev_logo.png";
import NavIcon from "../assets/sideNav/navIcon.png";
import search from "../assets/Users/search.png";
import cover from "../assets/login/loginCover.png";
import logo from "../assets/login/Ceviliyar.png";
import eyeClosedIcon from "../assets/login/eye-disable.png";
import booking from "../assets/dash/booking.png";
import revenue from "../assets/dash/revenue.png";
import green from "../assets/dash/green.png";
import blue from "../assets/dash/blue.png";
import violet from "../assets/dash/violet.png";
import down from "../assets/booking/down.png";
import usersI from "../assets/Users/users.png";
import downloads from "../assets/Users/downloads.png";
import appStoreIcon from "../assets/common/appStoreIcon.png";
import greenI from "../../src/assets/common/greenI.png";
import playStoreIcon from "../assets/common/playStoreIcon.png";
import nurseI from "../assets/common/nurseIcon.png";
import patientI from "../assets/common/patientIcon.png";
import purpel from "../assets/common/purpel.png";
import session from "../assets/engegment/session.png";
import greenArrow from "../assets/engegment/greenArrow.png";
import brownArrow from "../assets/engegment/brownArrow.png";
import chart from "../assets/booking/chart.png";
import userT from "../assets/booking/userT.png";
import freqency from "../assets/engegment/frequency.png";
import down1 from "../assets/booking/down.png";
import logo1 from "../assets/Ceviliyar.png";
import userEngagement from "../assets/userEngagement.png";
import moniterzation from "../assets/monitization.png";
import smallLogo from "../assets/common/smallLogo.png";
import navImage from "../assets/nav.png";
import engagementW from "../assets/sideNav/engageW.png";
import monitW from "../assets/sideNav/monitW.png";
import relation from "../assets/sideNav/relation.png";
import relationW from "../assets/sideNav/relationW.png";
import cover1 from "../assets/Users/viewCover.png";
import userIcon from "../assets/Users/userIcon.png";
import contactIcon from "../assets/Users/contactIcon.png";
import prev from "../assets/common/prev.png";
import filter from "../assets/filter.png";
import expand from "../assets/booking/expand.png";
import next from "../assets/common/next.png";
import generated from "../assets/monitization/revenueGen.png";
import reward from "../assets/monitization/reward.png";
import payFailed from "../assets/monitization/failed.png";
import paySuccess from "../assets/monitization/paymentSuccess.png";
import nursePay from "../assets/monitization/nursePay.png";
import phsioPay from "../assets/monitization/phsioPay.png";
import ourRevenue from "../assets/monitization/ourRevenue.png";
import purple from "../assets/common/purpel.png";
import verification from "../assets/common/verifiction.png";
import exp from "../assets/common/fi-rr-briefcase.png";
import Add from "../assets/common/addBtn.png";
import Razorpay from "../assets/common/razorpay.png";
import hospital from "../assets/common/hospital.png";
import agency from "../assets/common/agency.png";
import company from "../assets/common/company.png";
import pointTick from "../assets/common/pointTick.png";
import partnerBg from "../assets/common/partnerBG.png";
import report from "../assets/booking/pending1.png";
import calender from "../assets/booking/Average bookings.png";
import TotalBooking from "../assets/booking/totalBooking.png";
import success from "../assets/booking/cancelled.png";
import close from "../assets/common/close.png";
import ageI from "../assets/common/womanPatient.png";
import loadLottie from "../assets/lottie/ceviliyarLogoLoader.json";
import dashboardUnselect from "../assets/newSideNav/Dashboard-Unselected.png";
import dashboardSelect from "../assets/newSideNav/Dashboard-Selected.png";
import userAcquUnselect from "../assets/newSideNav/UserAcquisition-Unselected.png";
import userAcquSelect from "../assets/newSideNav/UserAcquisition-Selected.png";
import paymentUnselect from "../assets/newSideNav/Payment-Unselected.png";
import paymentSelect from "../assets/newSideNav/Payment-Selected.png";
import bookingUnselect from "../assets/newSideNav/Booking-Unselected.png";
import bookingSelect from "../assets/newSideNav/Booking-Selected.png";
import supportUnselect from "../assets/newSideNav/Support-Unselected.png";
import supportSelect from "../assets/newSideNav/Support-Selected.png";
import usersUnselected from "../assets/newSideNav/Users-Unselected.png";
import usersSelected from "../assets/newSideNav/Users-Selected.png";
import visitUnselected from "../assets/newSideNav/Visit-Unselected.png";
import visitSelected from "../assets/newSideNav/Visit-Selected.png";
import manageUnselected from "../assets/newSideNav/ManageAccess-Unselected.png";
import manageSelected from "../assets/newSideNav/ManageAccess-Selected.png";
import notificationUnselected from "../assets/newSideNav/Notification-Unselected.png";
import notificationSelected from "../assets/newSideNav/Notification-Selected.png";
import partnerUnselected from "../assets/newSideNav/partner-unselected.png";
import partnerSelected from "../assets/newSideNav/partner-selected.png";
import blockedUnselected from "../assets/newSideNav/blocked-unselected.png";
import blockedSelected from "../assets/newSideNav/blocked-selected.png";
import leadsUnselected from "../assets/newSideNav/Leads-Unselected.png";
import leadsSelected from "../assets/newSideNav/Leads-Selected.png";
import accountUnselected from "../assets/newSideNav/account-unselected.png";
import accountSelected from "../assets/newSideNav/account-selected.png";
import EnquiryUnselected from "../assets/newSideNav/Enquirylist-Unselected.png";
import EnquirySelected from "../assets/newSideNav/Enquirylist-Selected.png";
import csvUpload from "../assets/common/csvUpload.png";
import editIconBlue from "../assets/common/editIcon_blue.png";
import editIconGreen from "../assets/common/editIcon_green.png";
import nurseNew from "../assets/common/nurse.png";
import noDuty from "../assets/common/noDuty.png";
import VitalSignsImg from "../assets/services/vital-signs.png";
import PersonalCareImg from "../assets/services/personal-care.png";
import TransferImg from "../assets/services/transfer.png";
import CatheterCareImg from "../assets/services/catheter-care.png";
import InjectionImg from "../assets/services/back-care.png";
import BackCareImg from "../assets/services/back-care.png";
import MedicationManagementImg from "../assets/services/medication-management.png";
import NutritionImg from "../assets/services/nutrition.png";
import WoundCareImg from "../assets/services/wound-care.png";
import IVFluidImg from "../assets/services/back-care.png";
import OutputImg from "../assets/services/back-care.png";
import TracheostomyImg from "../assets/services/tracheostomy.png";
import SuppositoryImg from "../assets/services/suppository.png";
import AssessmentImg from "../assets/services/assessment.png";
import PainManagementImg from "../assets/services/back-care.png";
import ContinuousRylesImg from "../assets/services/back-care.png";
import HourlyRylesImg from "../assets/services/back-care.png";
import profileUnselected from "../assets/newSideNav/profile-unselect.png";
import profileSelected from "../assets/newSideNav/profile-selected.png";
import pricingUnselected from "../assets/newSideNav/pricing-unselect.png";
import pricingSelected from "../assets/newSideNav/pricing-selected.png";
import mctSelected from "../assets/newSideNav/mct-selected.png";
import mctUnselected from "../assets/newSideNav/mct-unselect.png";
import manageDutySelected from "../assets/newSideNav/manageduty-selected.png";
import manageDutyUnselected from "../assets/newSideNav/manageduty-unselect.png";
import menwithactive from "../assets/common/mendp_withactive.png";
import womenwithactive from "../assets/common/womandp_withactive.png";
import menwithoutactive from "../assets/common/mendp_withoutactive.png";
import womenwithoutactive from "../assets/common/womandp_withoutactive.png";
import commonactive from "../assets/common/commondp_withactive.png";
import commonwithoutactive from "../assets/common/commondp_withoutactive.png";
import partnerDefaultDp from "../assets/common/partnerImageCom.jpg";
import branch_s from "../assets/partnerside_nav/branch_selected.png";
import branch_u from "../assets/partnerside_nav/branch_un.png";
import visit_s from "../assets/partnerside_nav/visits_select.png";
import visit_u from "../assets/partnerside_nav/visits_un.png";
import payment_s from "../assets/partnerside_nav/payment_select.png";
import payment_u from "../assets/partnerside_nav/payments_un.png";
import booking_s from "../assets/partnerside_nav/bookings_selected.png";
import booking_u from "../assets/partnerside_nav/billings_un.png";
import support_s from "../assets/partnerside_nav/support_select.png";
import support_u from "../assets/partnerside_nav/support_un.png";
import billing_s from "../assets/partnerside_nav/billings_select.png";
import billing_u from "../assets/partnerside_nav/billings_un.png";
import service_s from "../assets/partnerside_nav/service_selected.png";
import service_u from "../assets/partnerside_nav/service_un.png";
import genderLess_physio from "../assets/partner/genderless_physio.png";
import genderLess_staff from "../assets/partner/genderless_staffs.png";

export const ServiceImages = {
  VitalSignsImg,
  PersonalCareImg,
  TransferImg,
  CatheterCareImg,
  InjectionImg,
  BackCareImg,
  MedicationManagementImg,
  NutritionImg,
  WoundCareImg,
  IVFluidImg,
  OutputImg,
  TracheostomyImg,
  SuppositoryImg,
  PainManagementImg,
  ContinuousRylesImg,
  HourlyRylesImg,
  AssessmentImg,
};

export const SideNavLatest = {
  dashboardUnselect,
  dashboardSelect,
  userAcquUnselect,
  userAcquSelect,
  paymentUnselect,
  paymentSelect,
  bookingUnselect,
  bookingSelect,
  supportUnselect,
  supportSelect,
  usersUnselected,
  usersSelected,
  visitSelected,
  visitUnselected,
  manageSelected,
  manageUnselected,
  notificationSelected,
  notificationUnselected,
  partnerSelected,
  partnerUnselected,
  blockedSelected,
  blockedUnselected,
  accountSelected,
  accountUnselected,
  leadsSelected,
  leadsUnselected,
  EnquirySelected,
  EnquiryUnselected,
  profileSelected,
  profileUnselected,
  pricingSelected,
  pricingUnselected,
  mctSelected,
  mctUnselected,
  manageDutySelected,
  manageDutyUnselected,
};


export const PartnerSideNavImages = {
  branch_s,
  branch_u,
  visit_s,
  visit_u,
  payment_s,
  payment_u,
  booking_s,
  booking_u,
  support_s,
  support_u,
  billing_s,
  billing_u,
  service_s,
  service_u,
}

export const CommonImages = {
  Up,
  userReg,
  appStore,
  playStore,
  active,
  defaultDp,
  CommonDp,
  emptyLogo,
  sender,
  newDp,
  male,
  female,
  NavIcon,
  CevIcon,
  purple,
  verification,
  exp,
  Add,
  Razorpay,
  hospital,
  agency,
  company,
  pointTick,
  partnerBg,
  report,
  calender,
  TotalBooking,
  success,
  close,
  ageI,
  loadLottie,
  csvUpload,
  editIconBlue,
  editIconGreen,
  nurseNew,
  noDuty,
  menwithactive,
  womenwithactive,
  menwithoutactive,
  womenwithoutactive,
  commonactive,
  commonwithoutactive,
};

export const topBarImages = {
  search,
};

export const partnerPortalImages = {
  partnerDefaultDp,
  genderLess_physio,
  genderLess_staff

};

export const LoginImages = {
  cover,
  logo,
  eyeClosedIcon,
};

export const DashboardImages = {
  booking,
  revenue,
  active,
  green,
  blue,
  violet,
};

export const UserAuqisitation = {
  down,
  usersI,
  downloads,
  appStoreIcon,
  greenI,
  playStoreIcon,
  nurseI,
  patientI,
  purpel,
};

export const UserEngagement = {
  session,
  greenArrow,
  brownArrow,
  chart,
  userT,
  freqency,
  down1,
};

export const SideNavImages = {
  logo1,

  userEngagement,

  moniterzation,

  smallLogo,
  navImage,

  engagementW,
  monitW,

  relation,
  relationW,
};

export const ProfileImages = {
  cover1,
  userIcon,
  contactIcon,
  prev,
  filter,
  expand,
  next,
};

export const MonitizationIcons = {
  generated,
  reward,
  payFailed,
  paySuccess,
  nursePay,
  phsioPay,
  ourRevenue,
};
